export enum UserType {
    FreightPayer = 0,
    Subcontractor = 1,
}